import { Card, CardContent, CardHeader, CardTitle } from '../ui/card.tsx';
import { Button } from '../ui/button.tsx';
import { X, Download } from 'lucide-react'; // Download ikonunu ekledik

interface Attendee {
    id: number;
    user_name: string;
    user_surname: string;
    user_email: string;
    GuestCount: number;
}

interface AttendeeModalProps {
    showAttendeeModal: boolean;
    setShowAttendeeModal: (value: boolean) => void;
    selectedEventName: string;
    attendeeList: Attendee[];
    handleDownloadExcel: () => void; // Excel indirme fonksiyonu eklendi
}

export function AttendeeModal({
    showAttendeeModal,
    setShowAttendeeModal,
    selectedEventName,
    attendeeList,
    handleDownloadExcel // Props'tan çekiyoruz
}: AttendeeModalProps) {
    if (!showAttendeeModal) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <Card className="w-full max-w-lg bg-white shadow-xl">
                <CardHeader className="flex flex-row justify-between items-start border-b pb-4">
                    <div>
                        <CardTitle className="text-lg">
                            Katılımcılar: {selectedEventName}
                        </CardTitle>
                        <div className="text-sm text-slate-500 mt-1">
                            Toplam Kayıt: <span className="font-bold text-blue-600">
                                {attendeeList.reduce((total, item) => total + 1 + item.GuestCount, 0)}
                            </span> Kişi (Üyeler + Misafirler)
                        </div>
                    </div>
                    
                    {/* Butonları yan yana koymak için bir div içine aldık */}
                    <div className="flex items-center gap-2">
                        {/* Excel İndirme Butonu */}
                        <Button 
                            variant="outline" 
                            size="sm"
                            onClick={handleDownloadExcel}
                            className="bg-green-50 text-green-700 hover:bg-green-100 hover:text-green-800 border-green-200 flex items-center gap-2"
                        >
                            <Download className="h-4 w-4" />
                            Excel İndir
                        </Button>

                        {/* Kapatma Butonu */}
                        <Button 
                            variant="ghost" 
                            size="icon" 
                            onClick={() => setShowAttendeeModal(false)}
                        >
                            <X className="h-5 w-5"/>
                        </Button>
                    </div>
                </CardHeader>
                <CardContent className="max-h-[60vh] overflow-y-auto pt-4">
                    {attendeeList.length === 0 ? (
                        <p className="text-center text-slate-500 py-8">
                            Henüz kayıtlı katılımcı yok.
                        </p>
                    ) : (
                        <table className="w-full text-sm">
                            <thead className="bg-slate-50 text-slate-700">
                                <tr>
                                    <th className="p-3 text-left">Ad Soyad</th>
                                    <th className="p-3 text-left">Email</th>
                                    <th className="p-3 text-center">Misafir</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y">
                                {attendeeList.map((att: any) => (
                                    <tr key={att.id} className="hover:bg-slate-50">
                                        <td className="p-3 font-medium">
                                            {att.user_name} {att.user_surname}
                                        </td>
                                        <td className="p-3 text-slate-600">{att.user_email}</td>
                                        <td className="p-3 text-center text-blue-600 font-bold">
                                            {att.GuestCount}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </CardContent>
            </Card>
        </div>
    );
}